import { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BetsButton from '../Vets/Button';
import {
  selectSolanaUSDCBalance,
  selectTokenBalance,
} from '../../redux/slices/walletSlice';
import { selectTokenBySymbol } from '../../redux/slices/tokenSlice';
import { Container, ModalContainer } from '../BaseModal';
import { formatUSD } from '../../common/currency';
import VetsTextInput from '../Vets/Inputs/Text';
import { useFlag } from '@unleash/proxy-client-react';
import { UNLEASH_ENABLED_BUY_VETS } from '../../constants';
import BackButton from '../BackButton';

const StyledInput = styled.div`
  height: 70px;
  width: 100%;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.background.primary};
  border: 1px solid ${({ theme }) => theme.text.secondary};
  color: ${({ theme }) => theme.text.secondary};
  font-size: 18px;
  font-family: Manrope;
  font-weight: 400;
  text-align: right;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
`;

const InputContainer = styled.div`
  display: flex;
  width: fit-content;
  max-width: 719px;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: relative;
`;

const Label = styled.p`
  font-family: Manrope;
  color: ${({ theme }) => theme.text.primary};
  font-size: 12px;
  font-weight: 400;
`;

export const ErrorLabel = styled.p`
  margin-top: 5px;
  font-family: Manrope;
  color: ${({ theme }) => theme.status.error.primary};
  font-size: 12px;
  font-weight: 400;
  &::first-letter {
    text-transform: uppercase;
  }
`;

const ImageContainer = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  padding: 0px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Image = styled.img`
  width: 36px;
  height: 36px;
`;

const NameContainer = styled.div``;

const Name = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 20px;
  font-weight: 500;
  font-family: Manrope;
`;

const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: -5px;
`;

const SubValue = styled.p`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 10px;
  font-family: Manrope;
  font-weight: 400;
`;

const UsdLabel = styled.p`
  margin-top: -3px;
  color: ${({ theme }) => theme.text.secondary};
  font-size: 14px;
  font-weight: 300;
  font-family: Manrope;
`;

const TokenInput = ({ label, value, subvalue, onClick }) => {
  return (
    <>
      <InputContainer onClick={onClick}>
        {label && <Label className='label'>{label}&nbsp;</Label>}
        <StyledInput>
          <ValueContainer>
            <p>{value}</p>
            {subvalue && <SubValue>{subvalue}</SubValue>}
          </ValueContainer>
        </StyledInput>
        <ImageContainer>
          <Image src='/usd.webp' />
          <NameContainer>
            <Name>Pay with</Name>
            <UsdLabel>USD</UsdLabel>
          </NameContainer>
        </ImageContainer>
      </InputContainer>
    </>
  );
};

const ButtonsContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  gap: 20px;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.text.title};
  font-size: 40px;
  font-weight: 600;
  font-family: Manrope;
`;

const BuyVets = () => {
  const enableBuyVets = useFlag(UNLEASH_ENABLED_BUY_VETS);

  const vetsToken = useSelector((state) =>
    selectTokenBySymbol(state, 'solana', 'VETS'),
  );
  const vetsBalance = useSelector((state) =>
    selectTokenBalance('solana', vetsToken?.address || '')(state),
  );
  const usdcBalance = useSelector(selectSolanaUSDCBalance);
  const [usdAmount, setUsdAmount] = useState(
    usdcBalance ? Math.trunc(usdcBalance * 100) / 100 : 0,
  );
  const navigate = useNavigate();

  return (
    <Container>
      <ModalContainer>
        <BackButton />
        <div>
          <Title>Buy VETS</Title>
        </div>
        <div>
          <VetsTextInput
            maxValue={usdcBalance ? Math.trunc(usdcBalance * 100) / 100 : 0}
            dark
            label='BUY AMOUNT'
            value={usdAmount}
            onChange={setUsdAmount}
            type='number'
          />
        </div>
        <TokenInput value={formatUSD(usdcBalance)} subvalue={'available'} />
        <ButtonsContainer>
          <BetsButton
            disabled={
              !enableBuyVets || usdAmount <= 0 || usdAmount > usdcBalance
            }
            fullWidth
            onClick={() => {
              if (enableBuyVets) {
                navigate(`/app/vets/buy/confirm?usdAmount=${usdAmount}`);
              }
            }}
          >
            Buy VETS
          </BetsButton>
        </ButtonsContainer>
      </ModalContainer>
    </Container>
  );
};

export default BuyVets;
